import { render, staticRenderFns } from "./ResultBadge.vue?vue&type=template&id=0503d4c4&"
import script from "./ResultBadge.vue?vue&type=script&lang=js&"
export * from "./ResultBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports